<template>
  <div class="nav" :class="getClass()" :id="'nav-container'+(isMobile ? '_mobile' : '')" :style="{ 'top' : notificationMessageHeight + 'px' }">
    <div v-if="isMobile" class="nav-title-container" @keydown="ariaClick" role="button" tabindex="0" @click="handleOpen()">
      <div class="nav-title">{{ $toUpperCase($t(`profile_menu_title`)) }}</div>
      <div v-if="isOpen" class="custom-menu-arrow custom-menu-arrow-up" :class="brandClass()"></div>
      <div v-else class="custom-menu-arrow custom-menu-arrow-down" :class="brandClass()"></div>
    </div>
    <div v-else class="nav-title-container" @click="handleOpen()">
      <div class="nav-title">{{ $toUpperCase($t(`profile_menu_title`)) }}</div>
      <div v-if="isOpen" class="custom-menu-arrow custom-menu-arrow-up" :class="brandClass()"></div>
      <div v-else class="custom-menu-arrow custom-menu-arrow-down" :class="brandClass()"></div>
    </div>
    <div class="sections-wrapper">
      <div class="sections">
        <div
          v-for="s of sections"
          :key="s.key"
          class="page"
          @keydown="ariaClick" role="button" tabindex="0"
          :class="{ selected: s.key === modelValue }"
          @click="select(s.key)"
        >
          {{ $t(`profile_menu_${s.key}`) }}
        </div>
        <div class="page logout" @keydown="ariaClick" role="button" tabindex="0" v-if="$c('show_profile_logout_button')" @click="doLogout()">{{$t('profile_menu_logout_button')}}</div>
        <OneLanguageSelection class="page lang" v-if="$c('show_language_selection')" :brandClass="brandClass()" />
      </div>
    </div>
  </div>
</template>

<script>
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import { defineAsyncComponent } from 'vue'

export default {
  inject:['$c', '$t', 'brandClass', '$toUpperCase'],
  emits: ['update:modelValue','doLogout'],
  name: "ProfileNav",
  mixins:[oneUtils.accessibilityMixin],
  props: {
    modelValue: {
      type: String,
      default: oneUtils.enums.profilePages.PERSONAL_DATA,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
    notificationMessageHeight: 0
  }),
  components: {
    OneLanguageSelection: defineAsyncComponent(() =>
      import('../../../../gcdm-one-library/gcdm-one-language-selection/src/OneLanguageSelection')
    )
  },
  computed: {
    sections() {
      const sections = [
        {
          key: oneUtils.enums.profilePages.PERSONAL_DATA,
          visible: this.isSectionVisible(oneUtils.enums.profilePages.PERSONAL_DATA),
        },
        {
          key: oneUtils.enums.profilePages.ACCOUNT_DATA,
          visible: this.isSectionVisible(oneUtils.enums.profilePages.ACCOUNT_DATA),
        },
        {
          key: oneUtils.enums.profilePages.ESIM,
          visible: this.isSectionVisible(oneUtils.enums.profilePages.ESIM),
        },
        {
          key: oneUtils.enums.profilePages.CONSENTS,
          visible: this.isSectionVisible(oneUtils.enums.profilePages.CONSENTS),
        },
        {
          key: oneUtils.enums.profilePages.BMW_PAY,
          visible: this.isSectionVisible(oneUtils.enums.profilePages.BMW_PAY),
        },
        {
          key: oneUtils.enums.profilePages.VEHICLES,
          visible: this.isSectionVisible(oneUtils.enums.profilePages.VEHICLES),
        },
        {
          key: oneUtils.enums.profilePages.DEALERS,
          visible: this.isSectionVisible(oneUtils.enums.profilePages.DEALERS),
        },
      ];
      return sections.filter((s) => s.visible);
    },
    message() {
      return this.$store.getters.getMessage;
    }
  },
  watch: {
    // "$route.query"() {
    //   this.selectSectionFromParams();
    // },
    sections(values) {
      const isCurrentSectionVisible = values.find((e) => e.key === this.modelValue);
      if (!isCurrentSectionVisible) {
        this.selectFirstOrNone();
      }
    },
    message(value) {
      Promise.resolve().then(() => {
        this.notificationMessageHeight = this.getNotificationMessageHeight();
      }, 0);
    }
  },
  mounted() {

    this.selectSectionFromParams();
    const elem = document.querySelector('#nav-container_mobile');
    elem.addEventListener('keydown',(e)=>{
      if(e.key === 'Esc' || e.key === 'Escape'){
        this.handleOpen()
      }
    });
  },
  methods: {
    getNotificationMessageHeight() {
      if(this.message?.content) {
        let element = document.getElementById("app-notification-message");

        if(element && window.getComputedStyle(element, null)?.display != "none") {
          return element.offsetHeight;
        }
      }

      return 0;
    },
    getClass(){
      if(this.$el){
        return { opened: this.isOpen, closed: !this.isOpen, isSticky: this.$el.classList.contains('isSticky') };
      }
    },
    doLogout(){
      this.$emit('doLogout');
    },
    selectFirstOrNone() {
      let selected = null;
      if (this.sections.length > 0) {
        selected = this.sections[0].key;
      }
      this.select(selected);
    },
    selectSectionFromParams() {
      let section = oneUtils.utils.getQueryParams().section;
      if(!section){
        section = window.localStorage.getItem("oneid_section");
      }
      if (
        section &&
        this.isValidSection(section) &&
        this.isSectionVisible(section)
      ) {
        this.select(section);
      } else {
        this.selectFirstOrNone();
      }
    },
    isSectionVisible(sectionKey) {
      const globalVisibility =
        this.$c(`show_${sectionKey}_section_global`) === undefined
          ? true
          : this.$c(`show_${sectionKey}_section_global`);
      const clientVisibility =
        this.$c(`show_${sectionKey}_section`) === undefined
          ? true
          : this.$c(`show_${sectionKey}_section`);
      return globalVisibility && clientVisibility;
    },
    select(pageKey) {
      oneUtils.utils.hideMessage();
      this.isOpen = false;
      if(!window['$startupwebcomponent']) window.localStorage.setItem("oneid_section", pageKey);
      this.$emit("update:modelValue", pageKey);
    },
    handleOpen() {
      this.isOpen = !this.isOpen;
    },
    isValidSection(section) {
      return Object.keys(oneUtils.enums.profilePages).some(
        (key) => oneUtils.enums.profilePages[key] === section
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-menu-arrow{
  width: 18px;
  background-size: contain;
  height: 18px;
  margin-left: 10px;
  display: none;
  @media screen and (max-width: 1024px) {
    display: block;
  }
}
.custom-menu-arrow-up{

  background-image: url('~@/assets/default/light/arrow-up-black-default-light.svg');

  &.__alphabet{
    background-image: url('~@/assets/alphabet/light/arrow-up-alphabet-light.svg');
  }
  &.__d{
    background-image: url('~@/assets/default/dark/arrow-up-default-dark.svg');
  }
  &.__rr{
    background-image: url('~@/assets/rr/light/arrow-up-white-rr-light.svg');
  }

}
.custom-menu-arrow-down{
  background-image: url('~@/assets/default/light/arrow-down-black-default-light.svg');

  &.__alphabet{
    background-image: url('~@/assets/alphabet/light/arrow-down-alphabet-light.svg');
  }
  &.__d{
    background-image: url('~@/assets/default/dark/arrow-down-default-dark.svg');
  }
  &.__rr{
    background-image: url('~@/assets/rr/light/arrow-down-white-rr-light.svg');
  }
}
</style>
